import { render } from "./operationDetail.vue?vue&type=template&id=18a395a2"
import script from "./operationDetail.vue?vue&type=script&lang=js"
export * from "./operationDetail.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__